module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"add_media":"添加照片/视频","add_photo":"添加照片","max_media_count":"（最多{0}个）","media_count_exceeded":"最多可上传 {0} 个，因此在选择的照片/视频中仅添加 {1} 个。","capture_excluded":"截图无法上传。将从所选照片/视频中排除后添加。","capture_excluded_and_media_count_exceeded":"将排除截图，并仅添加{0}个照片/视频。"}}')
  delete Component.options._Ctor
}
